/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './behavioural-pain-score.reducer';

export const BehaviouralPainScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const behaviouralPainScoreEntity = useAppSelector(state => state.behaviouralPainScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="behaviouralPainScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.detail.title">BehaviouralPainScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.id}</dd>
          <dt>
            <span id="facialExpression">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.facialExpression">Facial Expression</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.facialExpression}</dd>
          <dt>
            <span id="ventilationCompliance">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.ventilationCompliance">Ventilation Compliance</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.ventilationCompliance}</dd>
          <dt>
            <span id="upperLimbs">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.upperLimbs">Upper Limbs</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.upperLimbs}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{behaviouralPainScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.behaviouralPainScore.patient">Patient</Translate>
          </dt>
          <dd>{behaviouralPainScoreEntity.patient ? behaviouralPainScoreEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/behavioural-pain-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/behavioural-pain-score/${behaviouralPainScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BehaviouralPainScoreDetail;
